<div class="page-wrap d-flex flex-row align-items-center"
  style="min-height:100vh;background-color:#3a5161;opacity:0.95">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-7 m-3 text-center card">
        <div *ngIf="!errorText" class="m-4 lead">{{ 'PAGE-NOT-FOUND' | translate }}</div>
        <div *ngIf="errorText" class="m-4 lead">{{ errorText }}</div>
      </div>
    </div>
  </div>
</div>